import {ROLE_DEVELOPER, ROLE_BEHEERDER, ROLE_HELPDESK_MEDEWERKER, ROLE_ONTWIKKELAAR, ROLE_ONTWIKKELAAR_PLUS, ROLE_REDACTEUR} from '~/constants/roles';

export default ({store, redirect}) => {
  if (store.state.auth.loggedIn && ![ROLE_DEVELOPER, ROLE_BEHEERDER, ROLE_HELPDESK_MEDEWERKER, ROLE_REDACTEUR, ROLE_ONTWIKKELAAR, ROLE_ONTWIKKELAAR_PLUS].includes(store.state.auth.user.role_id)) {
    return redirect('/account');
  }
};
